/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
export var styles = [''];
//# sourceMappingURL=puzzle-2048.component.css.shim.js.map